// -- IMPORTS

import { writable } from 'svelte/store'

// -- CONSTANTS

export let textStore = writable( null )
